export default "__VITE_ASSET__2ch23LvD__";